import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "scrollContainer", "highlightCount", "nextBtn", "prevBtn", "showBtn", "uiControl"]

  connect() {
    this.markElements = this.textTarget.querySelectorAll('mark')
    this.currentMark = -1

    if (this.markElements.length > 1) {
      this.highlightCountTarget.innerText = `${this.markElements.length} highlights`
      this.nextBtnTarget.parentElement.classList.remove('d-none')
      this.showBtnTarget.classList.add('d-none')
    } else if (this.markElements.length === 1) {
      this.highlightCountTarget.innerText = `${this.markElements.length} highlight`
    } else {
      this.uiControlTarget.classList.remove('d-flex')
      this.uiControlTarget.classList.add('d-none')
    }

  }

  next() {
    if (this.currentMark < this.markElements.length - 1) {
      this.currentMark++
      this.showHighlight()
      this.updateControlUI()    }
  }

  previous() {
    console.log(this.currentMark)
    if (this.currentMark > 0) {
      this.currentMark--
      this.showHighlight()
      this.updateControlUI()    }
  }

  showHighlight() {
    this.markElements.forEach((mark) => { mark.classList.remove( 'outlined') })
    this.markElements[this.currentMark].classList.add( 'outlined')

    this.scrollIntoView(this.markElements[this.currentMark])
  }

  updateControlUI() {
    if (this.markElements.length < 2) {
      return
    }

    this.nextBtnTarget.innerHTML = '<i class="far fa-chevron-down"></i>'
    this.nextBtnTarget.parentElement.classList.remove('d-none')
    this.showBtnTarget.classList.add('d-none')
    this.highlightCountTarget.innerText = `${this.currentMark + 1} of ${this.markElements.length} highlights`
    this.nextBtnTarget.disabled = this.currentMark === this.markElements.length - 1
    this.nextBtnTarget.classList.toggle('disabled', this.currentMark === this.markElements.length - 1)
    this.prevBtnTarget.disabled = this.currentMark === 0
    this.prevBtnTarget.classList.toggle('disabled', this.currentMark === 0)
  }

  // Nicked from https://stackoverflow.com/a/45411081
  scrollIntoView(child) {

    // Where is the parent on page
    var parentRect = this.scrollContainerTarget.getBoundingClientRect();
    // What can you see?
    var parentViewableArea = {
      height: this.scrollContainerTarget.clientHeight,
      width: this.scrollContainerTarget.clientWidth
    };

    // Where is the child
    var childRect = child.getBoundingClientRect();
    // Is the child viewable?
    var isViewable = (childRect.top >= (parentRect.top)) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

    // if you can't see the child try to scroll parent
    if (!isViewable) {
          // Should we scroll using top or bottom? Find the smaller ABS adjustment
          // Add 100 so we don't have the element disappear behind the sticky header
          const scrollTop = childRect.top - (parentRect.top + 100);
          const scrollBot = childRect.bottom - parentRect.bottom;
          if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
              // we're near the top of the list
              this.scrollContainerTarget.scrollTop += scrollTop;
          } else {
              // we're near the bottom of the list
              this.scrollContainerTarget.scrollTop += scrollBot;
          }
    }

  }

}
